var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_361","data-name":"Group 361","transform":"translate(-7.484 10.313) rotate(-45)"},[React.createElement("line",{"id":"Line_21","data-name":"Line 21","x2":"25.169","transform":"translate(0 12.585)","fill":"none","stroke":"#ffbb5a","strokeLinecap":"round","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_22","data-name":"Line 22","x1":"25.169","transform":"translate(12.585) rotate(90)","fill":"none","stroke":"#ffbb5a","strokeLinecap":"round","strokeWidth":"2","key":1})]));
}

Close.defaultProps = {"width":"20.626","height":"20.626","viewBox":"0 0 20.626 20.626"};

module.exports = Close;

Close.default = Close;
